import { gsap, ScrollTrigger } from 'gsap/all'
import { splitText } from './split-text'
import { splitTitle } from './split-title'
import { fadeInUp } from './fade-in-up'
gsap.registerPlugin(ScrollTrigger)

export function structuresHighlight(element: HTMLElement) {
  const overlay = element.querySelector('.js-overlay') as HTMLElement
  const pinnedGroup = element.querySelector('.js-pinned-group') as HTMLElement
  const title = element.querySelector('.js-title') as HTMLElement
  const desc = element.querySelector('.js-desc') as HTMLElement
  const button = element.querySelector('.js-button') as HTMLElement
  const cards = [...Array.from(element.querySelectorAll('.js-card'))] as HTMLElement[]

  let mm = gsap.matchMedia()

  mm.add('(min-width: 992px)', () => {
    if (title) splitTitle(title, { trigger: element, start: 'top center', end: 'top+=25% center', markers: false })
    if (desc) splitText(desc, { trigger: element, start: 'top center', end: 'top+=25% center', markers: false })
    if (button) fadeInUp(button, { trigger: element, start: 'top center', end: 'top+=25% center', markers: false })
    gsap.set(cards, { yPercent: 25, opacity: 0 })

    //fix overlay to element using scriolltrigger
    ScrollTrigger.create({
      trigger: element,
      start: 'top top',
      end: 'bottom bottom',
      pin: overlay,
      pinSpacing: true
    })

    // pin text group
    ScrollTrigger.create({
      trigger: element,
      start: 'top top',
      end: `bottom-=${pinnedGroup.offsetHeight / 3} center`,
      pin: pinnedGroup,
      pinSpacing: false
      // markers: true
    })

    cards.forEach((card, index) => {
      gsap.to(card, {
        yPercent: 0,
        opacity: 1,
        ease: 'expo.out',
        duration: 1.2,
        scrollTrigger: {
          trigger: card,
          start: 'top 80%',
          end: 'bottom 80%',
          scrub: 1,
          invalidateOnRefresh: true
          // markers: true,
        }
      })
    })
  })
}
